module.exports = __webpack_public_path__ + "img/btn-arrow-free.7b8d2751.svg";